// import fillSupplierKey from './middlewares/fillSupplierKey'

module.exports = {
  model: 'suppliers',
  middlewares: [],
}



// WEBPACK FOOTER //
// ./src/views/suppliers.js